import { ConfigInterface } from 'swr';
import { api, useApi } from '@gik/core/api';
import { Product } from '../../core/models/gik/Product';
import { ResponsePromise } from 'ky';

export function getWishlistProducts(inkindRouteId: string): ResponsePromise {
  // TODO: move this to the dotnet/products and retrieve products?inkindId=
  return api.get(`inkinds/${inkindRouteId}/wishlistProducts`);
}

export function useWishlistProducts(inkindRouteId?: string, config?: ConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  // TODO: move this to the dotnet/products and retrieve products?inkindId=
  return useApi<Product[]>(inkindRouteId ? `inkinds/${inkindRouteId}/wishlistProducts` : null, config);
}
